import { __exportAll } from "./_virtual/_rolldown/runtime.js";
import "./kiosk_os.js";
import "./kiosk_device_type.js";
import "./mdm_provider.js";
//#region src/kiosk_device_type_helper.ts
var kiosk_device_type_helper_exports = /* @__PURE__ */ __exportAll({
	canUseMsr: () => canUseMsr,
	canUseScale: () => canUseScale,
	canUseScanner: () => canUseScanner,
	canUseStormAudioNav: () => canUseStormAudioNav,
	getKioskTouchProfile: () => getKioskTouchProfile,
	getMdmProvider: () => getMdmProvider,
	isLinebuster: () => isLinebuster,
	kioskIconUrlFromType: () => kioskIconUrlFromType,
	kioskRequiresExternalTouchDisplay: () => kioskRequiresExternalTouchDisplay,
	mdmIsAccessibleByNonBiteUsers: () => mdmIsAccessibleByNonBiteUsers,
	mdmSupportsFetchingRemoteUrl: () => mdmSupportsFetchingRemoteUrl,
	mdmSupportsFetchingStatus: () => mdmSupportsFetchingStatus,
	mdmSupportsOpeningDeviceUrl: () => mdmSupportsOpeningDeviceUrl,
	name: () => name,
	toKioskOs: () => toKioskOs
});
function toKioskOs(deviceType) {
	switch (getMdmProvider(deviceType)) {
		case "elo-view":
		case "esper":
		case "workspace-one": return "Android";
		case "chrome-os-flex": return "ChromeOS";
		case "signage-os": return "Tizen";
		case "simple-mdm": return "iOS";
	}
}
function mdmIsAccessibleByNonBiteUsers(deviceType) {
	switch (getMdmProvider(deviceType)) {
		case "elo-view":
		case "workspace-one": return true;
		case "chrome-os-flex":
		case "esper":
		case "signage-os":
		case "simple-mdm": return false;
	}
}
function mdmSupportsFetchingStatus(deviceType) {
	switch (getMdmProvider(deviceType)) {
		case "chrome-os-flex":
		case "elo-view":
		case "simple-mdm":
		case "workspace-one": return true;
		case "esper":
		case "signage-os": return false;
	}
}
function mdmSupportsOpeningDeviceUrl(deviceType) {
	switch (getMdmProvider(deviceType)) {
		case "chrome-os-flex":
		case "esper":
		case "signage-os":
		case "simple-mdm":
		case "workspace-one": return true;
		case "elo-view": return false;
	}
}
function mdmSupportsFetchingRemoteUrl(deviceType) {
	switch (getMdmProvider(deviceType)) {
		case "chrome-os-flex": return true;
		case "elo-view":
		case "esper":
		case "signage-os":
		case "simple-mdm":
		case "workspace-one": return false;
	}
}
function getMdmProvider(deviceType) {
	switch (deviceType) {
		case 3:
		case 4:
		case 5:
		case 6: return "elo-view";
		case 9:
		case 8: return "workspace-one";
		case 150:
		case 160:
		case 100:
		case 110:
		case 250:
		case 275:
		case 300:
		case 310:
		case 170:
		case 171:
		case 172:
		case 353:
		case 200:
		case 305:
		case 50: return "esper";
		case 415:
		case 11:
		case 10:
		case 401:
		case 400:
		case 361:
		case 362:
		case 375:
		case 440:
		case 460:
		case 420:
		case 450:
		case 352:
		case 351:
		case 430: return "chrome-os-flex";
		case 1:
		case 2: return "simple-mdm";
		case 350: return "signage-os";
	}
}
function name(deviceType) {
	switch (deviceType) {
		case 3: return "Android Elo 15\"";
		case 4: return "Android Elo 22\"";
		case 5: return "Android Elo 22\" + Backpack";
		case 6: return "Android Elo 32\" + Backpack";
		case 9: return "Android Elo 22\" w/ Workspace One";
		case 8: return "Android Elo Backpack w/ Workspace One";
		case 150: return "Android HP Engage Pro 19.5\"";
		case 160: return "Android HP Engage Pro 24\"";
		case 100: return "Android Lenovo K10";
		case 110: return "Android Lenovo M90n";
		case 250: return "Android MicroTouch 22\"";
		case 275: return "Android Posiflex Mercury EK";
		case 300: return "Android Pyramid Flex 21.5\"";
		case 310: return "Android Flytech / Acrelec";
		case 170: return "Android Samsung Galaxy Tab A Series";
		case 171: return "Android Samsung Galaxy Tab Active Pro Series";
		case 172: return "Android Samsung Galaxy Tab S Series";
		case 353: return "Android Samsung Flytech";
		case 200: return "Android Sunmi 21.5\"";
		case 305: return "Android Touch Dynamic";
		case 50: return "Android Zebra ET40";
		case 415: return "ChromeOS Acrelec K22";
		case 11: return "ChromeOS Elo 15\"";
		case 10: return "ChromeOS Elo 22\"";
		case 401: return "ChromeOS HP Engage Pro 19.5\"";
		case 400: return "ChromeOS HP Engage Pro 24\"";
		case 361: return "ChromeOS Lenovo ChromeBox";
		case 362: return "ChromeOS Lenovo M90n";
		case 375: return "ChromeOS LG 27\"";
		case 440: return "ChromeOS MicroTouch 22\"";
		case 460: return "ChromeOS NCR 7360";
		case 420: return "ChromeOS Posiflex Mercury EK";
		case 450: return "ChromeOS Pyramid Passport 32\"";
		case 352: return "ChromeOS Samsung Lenovo ChromeBox";
		case 351: return "ChromeOS Samsung (KM24C/W)";
		case 430: return "ChromeOS TouchDynamic Edge Ultra 22\"";
		case 1: return "iPad 10\"";
		case 2: return "iPad Pro 12.9\"";
		case 350: return "Samsung Tizen (KM24A)";
	}
}
function canUseMsr(deviceType) {
	switch (deviceType) {
		case 3:
		case 4:
		case 5:
		case 6:
		case 9:
		case 8:
		case 160:
		case 150:
		case 100:
		case 110:
		case 250:
		case 275:
		case 300:
		case 310:
		case 353:
		case 200:
		case 305:
		case 50:
		case 415:
		case 11:
		case 10:
		case 401:
		case 400:
		case 361:
		case 362:
		case 375:
		case 440:
		case 420:
		case 450:
		case 352:
		case 351:
		case 430: return true;
		case 170:
		case 171:
		case 172:
		case 460:
		case 1:
		case 2:
		case 350: return false;
	}
}
function canUseScanner(deviceType) {
	switch (deviceType) {
		case 3:
		case 4:
		case 5:
		case 9:
		case 8:
		case 6:
		case 150:
		case 160:
		case 100:
		case 110:
		case 250:
		case 275:
		case 300:
		case 310:
		case 353:
		case 200:
		case 50:
		case 305:
		case 415:
		case 11:
		case 10:
		case 401:
		case 400:
		case 361:
		case 362:
		case 375:
		case 440:
		case 460:
		case 420:
		case 450:
		case 352:
		case 351:
		case 430:
		case 350: return true;
		case 170:
		case 171:
		case 172:
		case 1:
		case 2: return false;
	}
}
function canUseScale(deviceType) {
	switch (deviceType) {
		case 3:
		case 4:
		case 5:
		case 6:
		case 9:
		case 8:
		case 150:
		case 160:
		case 100:
		case 110:
		case 250:
		case 275:
		case 300:
		case 310:
		case 200:
		case 305:
		case 50: return true;
		case 170:
		case 171:
		case 172:
		case 353:
		case 415:
		case 11:
		case 10:
		case 401:
		case 400:
		case 361:
		case 362:
		case 375:
		case 440:
		case 460:
		case 420:
		case 450:
		case 352:
		case 351:
		case 430:
		case 1:
		case 2:
		case 350: return false;
	}
}
function canUseStormAudioNav(deviceType) {
	switch (deviceType) {
		case 3:
		case 4:
		case 5:
		case 6:
		case 9:
		case 8:
		case 150:
		case 160:
		case 110:
		case 250:
		case 275:
		case 300:
		case 310:
		case 200:
		case 305:
		case 415:
		case 11:
		case 10:
		case 401:
		case 400:
		case 361:
		case 362:
		case 375:
		case 440:
		case 420:
		case 450:
		case 430: return true;
		case 100:
		case 170:
		case 171:
		case 172:
		case 353:
		case 50:
		case 460:
		case 352:
		case 351:
		case 1:
		case 2:
		case 350: return false;
	}
}
function getKioskTouchProfile(deviceType) {
	switch (deviceType) {
		case 3:
		case 4:
		case 5:
		case 6:
		case 8:
		case 9: return {
			dragSensitivityX: 11,
			dragSensitivityY: 19,
			pressTimeThreshold: void 0,
			pressVelocityThreshold: .2
		};
		case 361: return {
			dragSensitivityX: 100,
			dragSensitivityY: 15,
			pressTimeThreshold: 150,
			pressVelocityThreshold: .1
		};
		case 352: return {
			dragSensitivityX: 15,
			dragSensitivityY: 15,
			pressTimeThreshold: 150,
			pressVelocityThreshold: void 0
		};
		case 420:
		case 430: return {
			dragSensitivityX: 11,
			dragSensitivityY: 19,
			pressTimeThreshold: 400,
			pressVelocityThreshold: .2
		};
		case 415: return {
			dragSensitivityX: 11,
			dragSensitivityY: 19,
			pressTimeThreshold: void 0,
			pressVelocityThreshold: .2
		};
		case 10:
		case 11: return {
			dragSensitivityX: 11,
			dragSensitivityY: 19,
			pressTimeThreshold: 400,
			pressVelocityThreshold: .1
		};
		case 250: return {
			dragSensitivityX: 150,
			dragSensitivityY: 30,
			pressTimeThreshold: void 0,
			pressVelocityThreshold: void 0,
			minPressDurationMs: 30
		};
		case 1:
		case 2:
		case 50:
		case 100:
		case 110:
		case 150:
		case 160:
		case 170:
		case 171:
		case 172:
		case 353:
		case 200:
		case 275:
		case 300:
		case 310:
		case 305:
		case 350:
		case 362:
		case 375:
		case 400:
		case 401:
		case 440:
		case 460:
		case 450:
		case 351: return {
			dragSensitivityX: 150,
			dragSensitivityY: 30,
			pressTimeThreshold: void 0,
			pressVelocityThreshold: void 0
		};
	}
}
function kioskRequiresExternalTouchDisplay(deviceType) {
	switch (deviceType) {
		case 5:
		case 6:
		case 8: return true;
		case 3:
		case 4:
		case 9:
		case 150:
		case 160:
		case 170:
		case 171:
		case 172:
		case 353:
		case 100:
		case 110:
		case 250:
		case 275:
		case 300:
		case 310:
		case 200:
		case 50:
		case 305:
		case 415:
		case 11:
		case 10:
		case 401:
		case 400:
		case 361:
		case 362:
		case 375:
		case 440:
		case 460:
		case 420:
		case 450:
		case 352:
		case 351:
		case 430:
		case 1:
		case 2:
		case 350: return false;
	}
}
function kioskIconUrlFromType(deviceType) {
	switch (deviceType) {
		case 3: return "https://static.bureau.getbite.com/images/status-kiosk-elo-android-15@2x.png";
		case 4: return "https://static.bureau.getbite.com/images/status-kiosk-elo-android-22@2x.png";
		case 5: return "https://static.bureau.getbite.com/images/status-kiosk-elo-android-22-backpack@2x.png";
		case 9:
		case 8: return "https://static.bureau.getbite.com/images/status-kiosk-elo-android-22-workspaceone@2x.png";
		case 6: return "https://static.bureau.getbite.com/images/status-kiosk-elo-android-32-backpack-frame@2x.png";
		case 150:
		case 160: return null;
		case 170:
		case 171:
		case 172: return "https://static.bureau.getbite.com/images/status-kiosk-samsung-android@2x.png";
		case 353: return "https://static.bureau.getbite.com/images/status-kiosk-samsung-tizen@2x.png";
		case 100:
		case 110: return "https://static.bureau.getbite.com/images/status-kiosk-lenovo-android@2x.png";
		case 250: return "https://static.bureau.getbite.com/images/status-kiosk-micro-touch-android-22@2x.png";
		case 275: return "https://static.bureau.getbite.com/images/status-kiosk-posiflex-android@2x.png";
		case 300: return null;
		case 310: return "https://static.bureau.getbite.com/images/status-kiosk-flytech-android-acrelec@2x.png";
		case 200: return "https://static.bureau.getbite.com/images/status-kiosk-sunmi-android-215@2x.png";
		case 305: return "https://static.bureau.getbite.com/images/status-kiosk-touch-dynamic-android@2x.png";
		case 50: return "https://static.bureau.getbite.com/images/status-kiosk-zebra-et40@2x.png";
		case 415:
		case 11:
		case 10:
		case 401:
		case 400:
		case 361:
		case 362:
		case 375:
		case 440:
		case 460:
		case 420:
		case 352:
		case 351:
		case 430: return "https://static.bureau.getbite.com/images/status-kiosk-chrome@2x.png";
		case 450: return "https://static.bureau.getbite.com/images/status-kiosk-pyramid-chromeos@2x.png";
		case 1: return "https://static.bureau.getbite.com/images/status-kiosk-ios-10@2x.png";
		case 2: return "https://static.bureau.getbite.com/images/status-kiosk-ios-13@2x.png";
		case 350: return "https://static.bureau.getbite.com/images/status-kiosk-samsung-tizen@2x.png";
	}
}
function isLinebuster(deviceType) {
	switch (deviceType) {
		case 100:
		case 170:
		case 171:
		case 172:
		case 50:
		case 1:
		case 2: return true;
		case 3:
		case 4:
		case 5:
		case 9:
		case 6:
		case 8:
		case 310:
		case 150:
		case 160:
		case 110:
		case 250:
		case 275:
		case 300:
		case 353:
		case 200:
		case 305:
		case 415:
		case 11:
		case 10:
		case 401:
		case 400:
		case 361:
		case 362:
		case 375:
		case 440:
		case 460:
		case 420:
		case 450:
		case 352:
		case 351:
		case 430:
		case 350: return false;
	}
}
//#endregion
export { canUseMsr, canUseScale, canUseScanner, canUseStormAudioNav, getKioskTouchProfile, getMdmProvider, isLinebuster, kioskIconUrlFromType, kioskRequiresExternalTouchDisplay, kiosk_device_type_helper_exports, mdmIsAccessibleByNonBiteUsers, mdmSupportsFetchingRemoteUrl, mdmSupportsFetchingStatus, mdmSupportsOpeningDeviceUrl, name, toKioskOs };

//# sourceMappingURL=kiosk_device_type_helper.js.map